package one.healthium.uscreen.ui

import androidx.compose.runtime.Immutable

@Immutable
sealed interface UScreenAnswer {
    data class ChoiceAnswer(val selectedKeys: List<String>) : UScreenAnswer
    data class TextAnswer(val text: String) : UScreenAnswer
    data class NumberAnswer(val value: Float) : UScreenAnswer
}
